module.exports = __webpack_public_path__ + "static/logo-f40452efc7899ea76782d2f44732265d.svg";